<template>
  <v-content style="position: relative;" class="tablet">
    <v-snackbar v-model="snackbar" :timeout='2000' top>{{ snackbarMessage }}</v-snackbar>
    <v-flex style="position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
      <v-flex xs12 v-show="frontPage && hasContractorRole">
        <v-btn @click="gotoProduction" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start production
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasCreatePalletRole">
        <v-btn @click="gotoCreatePallet" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Create pallet
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasLoaderRole || hasCarrierRole || hasSupplierRole)">
        <v-btn @click="gotoLoading" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start loading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasLoaderRole || hasCarrierRole || hasSupplierRole)">
        <v-btn @click="gotoUnloading" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start unloading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasRepackagingRole">
        <v-btn @click="gotoRepackaging" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start repackaging
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasLabellerRole">
        <v-btn @click="gotoLabelling" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start labelling
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasForecastRole">
        <v-btn @click="gotoForecast" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Forecast
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasTimeRegistrationRole">
        <v-btn @click="gotoTimeRegistration" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Time registration
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasSupplierRole)">
        <v-btn @click="gotoProductionOverview" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Production overview
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasSupplierRole">
        <v-btn @click="gotoReports" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Reports
        </v-btn>
      </v-flex>
    </v-flex>

    <TodoProduction v-if="productionVisible"/>
    <TodoCreatePallet v-if="createPalletVisible"/>
    <TodoLoading v-if="loadingVisible"/>
    <TodoUnloading v-if="unloadingVisible"/>
    <TodoRepackaging v-if="repackagingVisible"/>
    <TodoLabelling v-if="labellingVisible"/>
    <TodoTimeRegistration v-if="timeRegistrationVisible"/>
    <ProductionOverview v-if="productionOverviewVisible"/>
    <Reports v-if="teportsVisible"/>
    <Forecast :edit-category-families="hasForecastRole" v-if="forecastVisible"/>
  </v-content>
</template>

<script>
import Forecast from './Forecast'
import Panel from '../components/Panel'
import ProductionOverview from './ProductionOverview.vue'
import Reports from './Reports.vue'
import TodoCreatePallet from './TodoCreatePallet'
import TodoLabelling from './TodoLabelling'
import TodoLoading from './TodoLoading'
import TodoProduction from './TodoProduction'
import TodoRepackaging from './TodoRepackaging'
import TodoTimeRegistration from './TodoTimeRegistration'
import TodoUnloading from './TodoUnloading'

export default {
  name: 'Content',
  components: { Panel, TodoProduction, TodoCreatePallet, TodoLabelling, TodoLoading, TodoUnloading, TodoRepackaging, ProductionOverview, Forecast, Reports, TodoTimeRegistration },
  data () {
    return {
      frontPage: true,
      productionVisible: false,
      createPalletVisible: false,
      loadingVisible: false,
      unloadingVisible: false,
      repackagingVisible: false,
      labellingVisible: false,
      forecastVisible: false,
      timeRegistrationVisible: false,
      productionOverviewVisible: false,
      teportsVisible: false,
      snackbar: false,
      snackbarMessage: ''
    }
  },
  created: function () {
  },
  computed: {
    fullName: function () {
      return this.$store.state.session.fullName
    },
    roles: function () {
      return this.$store.state.session.roles
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR') && !this.hasTimeRegistrationRole
    },
    hasCreatePalletRole: function () {
      return this.$store.getters['session/hasRole']('CREATE_PALLET') && !this.hasTimeRegistrationRole
    },
    hasCustomerRole: function () {
      return this.$store.getters['session/hasRole']('CUSTOMER') && !this.hasTimeRegistrationRole
    },
    hasLoaderRole: function () {
      return this.$store.getters['session/hasRole']('LOADER') && !this.hasTimeRegistrationRole
    },
    hasSupplierRole: function () {
      return this.$store.getters['session/hasRole']('SUPPLIER') && !this.hasTimeRegistrationRole
    },
    hasCarrierRole: function () {
      return this.$store.getters['session/hasRole']('CARRIER') && !this.hasTimeRegistrationRole
    },
    hasRepackagingRole: function () {
      return this.$store.getters['session/hasRole']('REPACKAGING') && !this.hasTimeRegistrationRole
    },
    hasLabellerRole: function () {
      return this.$store.getters['session/hasRole']('LABELLER') && !this.hasTimeRegistrationRole
    },
    hasForecastRole: function () {
      return this.$store.getters['session/hasRole']('FORECAST') && !this.hasTimeRegistrationRole
    },
    hasTimeRegistrationRole: function () {
      return this.$store.getters['session/hasRole']('TIME_REGISTRATION')
    },
    numberOfFrontPageButtons: function () {
      let number = 0
      if (this.hasContractorRole) {
        number++
      }
      if (this.hasCreatePalletRole) {
        number++
      }
      if (this.hasContractorRole || this.hasLoaderRole || this.hasCarrierRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasContractorRole || this.hasLoaderRole || this.hasCarrierRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasContractorRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasSupplierRole) {
        number++
      }
      if (this.hasRepackagingRole) {
        number++
      }
      if (this.hasLabellerRole) {
        number++
      }
      if (this.hasForecastRole) {
        number++
      }
      if (this.hasTimeRegistrationRole) {
        number++
      }
      return number
    }
  },
  methods: {
    showMessage (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    gotoHome: function () {
      this.frontPage = true
      this.productionVisible = false
      this.createPalletVisible = false
      this.loadingVisible = false
      this.unloadingVisible = false
      this.repackagingVisible = false
      this.labellingVisible = false
      this.forecastVisible = false
      this.timeRegistrationVisible = false
      this.productionOverviewVisible = false
      this.teportsVisible = false
    },
    gotoProduction: function () {
      this.frontPage = false
      this.productionVisible = true
    },
    gotoCreatePallet: function () {
      this.frontPage = false
      this.createPalletVisible = true
    },
    gotoLoading: function () {
      this.frontPage = false
      this.loadingVisible = true
    },
    gotoUnloading: function () {
      this.frontPage = false
      this.unloadingVisible = true
    },
    gotoRepackaging: function () {
      this.frontPage = false
      this.repackagingVisible = true
    },
    gotoLabelling: function () {
      this.frontPage = false
      this.labellingVisible = true
    },
    gotoForecast: function () {
      this.frontPage = false
      this.forecastVisible = true
    },
    gotoTimeRegistration: function () {
      this.frontPage = false
      this.timeRegistrationVisible = true
    },
    gotoProductionOverview: function () {
      this.frontPage = false
      this.productionOverviewVisible = true
    },
    gotoReports: function () {
      this.frontPage = false
      this.teportsVisible = true
    },
    loadContractorPallets: function () {
      this.$store.dispatch('contractor/loadPallets')
    }
  }
}
</script>

<style>
  @import '../assets/css/tablet.css';
</style>



// WEBPACK FOOTER //
// src/components/Todo.vue